export const __VERSION__ = '2.10.6';
